import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import Home from "@/views/Home.vue";
import Callback from "@/views/Callback.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { breadcrumb: "Home", requiresAuth: true, formName: "Home" },
  },
  {
    path: "/weather",
    name: "Weather",
    component: () => import("@/views/Weather.vue"),
    meta: { breadcrumb: "Weather", requiresAuth: true, formName: "Weather" },
  },
  {
    path: "/trails",
    name: "Trails",
    component: () => import("@/views/Trails.vue"),
    meta: { breadcrumb: "Trail Information", requiresAuth: true, formName: "Trails" },
  },
  {
    path: "/carpark",
    name: "CarPark",
    component: () => import("@/views/CarPark.vue"),
    meta: { breadcrumb: "Car Park", requiresAuth: true, formName: "CarPark" },
  },
  {
    path: "/footfall",
    name: "Footfall",
    component: () => import("@/views/FootfallSettings.vue"),
    meta: { breadcrumb: "Footfall", requiresAuth: true, formName: "Footfall" },
  },
  {
    path: "/safety",
    name: "SafetyPage",
    component: () => import("@/views/SafetyPage.vue"),
    meta: { breadcrumb: "Safety Page", requiresAuth: true, formName: "SafetyPage" },
  },
  {
    path: "/erosion",
    name: "ErosionPage",
    component: () => import("@/views/ErosionPage.vue"),
    meta: { breadcrumb: "Enjoy the Outdoors", requiresAuth: true, formName: "ErosionPage" },
  },
  {
    path: "/notifications",
    name: "NotificationsPage",
    component: () => import("@/views/NotificationsPage.vue"),
    meta: { breadcrumb: "Notifications Page", requiresAuth: true, formName: "NotificationsPage" },
  },
  {
    path: "/disclaimer",
    name: "DisclaimerPage",
    component: () => import("@/views/DisclaimerPage.vue"),
    meta: { breadcrumb: "Disclaimer", requiresAuth: true, formName: "DisclaimerPage" },
  },
  {
    path: "/emails",
    name: "EmailsPage",
    component: () => import("@/views/EmailsPage.vue"),
    meta: { breadcrumb: "Emails", requiresAuth: true, formName: "EmailsPage" },
  },
  {
    path: "/bookings",
    name: "Bookings",
    component: () => import("@/views/Bookings.vue"),
    meta: { breadcrumb: "Bookings", requiresAuth: true, formName: "Bookings" },
  },
  {
    path: "/bookings/:id",
    name: "BookingDetail",
    component: () => import("@/views/BookingDetail.vue"),
    meta: { breadcrumb: "Booking Detail", requiresAuth: true, formName: "Bookings" },
  },
  {
    path: "/documents",
    name: "Documents",
    component: () => import("@/views/Documents.vue"),
    meta: { breadcrumb: "Documents", requiresAuth: true, formName: "Documents" },
  },
  {
    path: "/users",
    name: "Users",
    component: () => import("@/views/UserManager.vue"),
    meta: { breadcrumb: "Users", requiresAuth: true, formName: "UserManager" },
  },
  {
    path: "/logs",
    name: "Logs",
    component: () => import("@/views/Logs.vue"),
    meta: { breadcrumb: "Logs", requiresAuth: true, formName: "Logs" },
  },
  { path: "/callback", name: "Callback", component: Callback },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  const auth = useAuthStore();

  if (to.name === "Callback") {
    return true;
  }

  await auth.init();

  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    auth.login(to.fullPath);
    return false;
  }

  return true;
});

export default router;
